import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const uniformPurchaseList = createAsyncThunk(
  'uniform-purchase-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform-purchase/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeUniformPurchase = createAsyncThunk(
  'uniform-purchase-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-uniform-purchase/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getUniformPurchaseById = createAsyncThunk(
  'uniform-purchase-get',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform-purchase/edit/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const approveUniformPurchase = createAsyncThunk(
  'uniform-purchase-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-uniform-purchase/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const viewUniformPurchase = createAsyncThunk(
  'uniform-purchase-view',
  async (purchase_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform-purchase/view/` + purchase_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

type UniformPurchaseState = {
  errors: any
}

const initialState: UniformPurchaseState = {
  errors: '',
}

export const uniformPurchaseSlice = createSlice({
  name: 'book-purchase',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeUniformPurchase.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = uniformPurchaseSlice.actions
export default uniformPurchaseSlice.reducer
